export const changeFilterURL = ({ url }) => ({
  type: 'FILTER_CHANGE_LOCATION',
  payload: {
    params: { url }
  }
})



// WEBPACK FOOTER //
// ./src/App/Breadcrumb/actions.js